export const CLEAR_AUTH_TOKEN = 'CLEAR_AUTH_TOKEN'
export const CLEAR_CURRENT_USER = 'CLEAR_CURRENT_USER'
export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN'
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const SET_EMAIL = 'SET_EMAIL'
export const SET_PASSWORD = 'SET_PASSWORD'
export const SET_PASSWORD_CONFIRMATION = 'SET_PASSWORD_CONFIRMATION'
export const SET_WORKSPACE = 'SET_WORKSPACE'
export const NEW_PASSWORD_FORM_REQUEST = 'NEW_PASSWORD_FORM_REQUEST'
export const SET_TOKEN = 'SET_TOKEN'



// WEBPACK FOOTER //
// ./src/store/modules/auth/types.js